import React from "react";
import {
    Box,
    Grid,
    Typography,
} from "@mui/material";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import theme from "../../utils/themeUtil";
import TextSize from "../../utils/textSizeUtil";

const sections = [
    {
        color: theme.palette.carrot.main,
        icon: AppIcons.imgTechnicalSupport,
        text: Strings.getAccessExpert,
    },
    {
        color: theme.palette.purple.main,
        icon: AppIcons.imgVerify,
        text: Strings.ourProductsSubHeading,
    },
    {
        color: theme.palette.lightGreen.main,
        icon: AppIcons.imgEventLive,
        text: Strings.getAccessEvents,
    },
];

const GetExpertEventAccess = () => (
    <Box bgcolor={theme.palette.white.main} py={isMobile ? 0 : 5}>
        <Box className={styles.container}>
            <Grid container spacing={2}>
                {sections.map((section, index) => (
                    <Grid key={index} item xs={12} md={4} style={{ textAlign: "left" }}>
                        <Box
                            bgcolor={section.color}
                            boxShadow={3}
                            borderRadius={4}
                            textAlign="center"
                            p={isMobile ? 2 : 5}
                            mb={2}
                        >
                            <img src={section.icon} height="160px" alt={section.text} />
                            <Box height={isMobile ? 'auto' : "145px"}>
                                <Typography
                                    style={{
                                        fontSize: isMobile ? TextSize.size18 : TextSize.size24,
                                        color: theme.palette.white.main,
                                        fontWeight: '500'
                                    }}
                                >
                                    {section.text}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    </Box>
);

export default GetExpertEventAccess;
